module.exports = __webpack_public_path__ + "img/login_left_bac.d29abd30.png";